import React from "react";
import { Section, Glass, Reveal } from "@/components/network/NetworkAtoms";
import { Landmark, HandCoins, ShieldOff } from "lucide-react";

const CARDS = [
  {
    Icon: Landmark,
    title: "Who we actually are",
    body: "A specialist commercial finance desk. Our people have spent more than twenty years in financial "
        + "services, and the funders we place business with include names that have been lending to UK "
        + "companies for over five decades — banks, challenger banks, independents and specialists.",
  },
  {
    Icon: ShieldOff,
    title: "What we're not",
    body: "We're not a lender, and we're not a comparison site that sells your details to whoever pays most. "
        + "Nobody buys your enquiry from us. Your application goes only to funders we've picked for your "
        + "situation, and you'll be told who is looking at it before anything at all is agreed.",
  },
  {
    Icon: HandCoins,
    title: "Why it costs you nothing",
    body: "When a funder writes the deal, the funder pays us. That's the entire model — no fee to you, no "
        + "charge for the conversation, and no obligation to accept anything you're offered. If the numbers "
        + "don't work for your business, we'll say so rather than talk you into them. No invoice, ever.",
  },
];

export default function WhoWeAre() {
  return (
    <Section
      testId="funding-who-we-are"
      eyebrow="Straight answers"
      title="Before you tell us anything, here's who you're dealing with"
      lede="Most people arrive here because an introducer sent them, or because they're about to hand over
            information about their business and want to know who's on the other end. Fair enough."
    >
      <div className="mt-12 grid md:grid-cols-3 gap-5">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.08}>
            <Glass className="h-full p-7">
              <c.Icon className="size-5 text-[#7da9ff]" />
              <h3 className="mt-5 font-cabinet text-[20px] font-semibold text-white tracking-[-0.02em]">{c.title}</h3>
              <p className="mt-3 text-[14.5px] leading-relaxed text-slate-300">{c.body}</p>
            </Glass>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
